module.exports = __webpack_public_path__ + "img/small-ship-wreck-b.68d4426f.png";